// 英文
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "Records",
    emptyRecords: "No Fruit Roulette records yet",
    guessResult: "Result",
    myGuesses: "My guesses",
    guessFailed: "Incorrect guess",
    winningPlayers: "Winning players",
    noGuesses: "You did not place any guesses this round",
    noWinners: "No winning players this round",
    rulesTitle: "How to play",
    rulesDescription: "Each round gives you 50 seconds to guess which fruit will appear. A correct guess earns the corresponding dew reward.",
    guessingTitle: "How to guess",
    guessingDescription: "During the guessing period, choose the amount of dew to wager and tap a fruit’s betting area to place your guess.",
    rewardsTitle: "Rewards",
    rewardsDescription: "Different fruits offer different dew rewards.",
    fruit: "Fruit",
    multiplier: "Reward multiplier",
    apple: "Apple",
    watermelon: "Watermelon",
    orange: "Orange",
    banana: "Banana",
    grape: "Grapes",
  },
  setPresident: {
    intro: "You can set the Boss to help manage your club",
    selfIntro: "You are the Boss of the club",
    president: "Boss",
    empty: "Not set Boss",
    appoint: "Appointment",
    privileges: "Boss's Functions",
    privilegesIntro: "The Boss has the following functions",
    title: "Setup Boss",
    selectMember: "Select the member you wish to setup as Boss",
    member: "Club member",
    attendance: "Present for {days} days",
    weekContribution: "Reputation Contribution (Weekly):",
    monthContribution: "(Month):",
    confirmAppoint: "Appoint this member as the Boss?",
    confirm: "Sure",
    remove: "Rescind Appointment",
    cancel: "Cancel",
    removeTitle: "Remove Boss Appointment",
    confirmRemove: "Are you sure you want to remove the appointment of Boss {name}?",
    unnamed: "Unnamed",
    pkTitle: "PK Room",
    pkDesc: "The Boss can open, close, and manage the PK room of this club",
    infoTitle: "Club Information",
    infoDesc: "The Boss and the lord have the authority to edit the club cover, name, declaration, and other club information",
    membersTitle: "Member Management",
    membersDesc: "The Boss and the lord both have the authority to expel members and guests from the club.",
    rewardsTitle: "Club Reward",
    rewardsDesc: "The Boss can collect the rewards related to the club, if there is no Boss set, it is no way to collect",
    moderationTitle: "Live room manager",
    moderationDesc: "The Boss automatically obtains the control permission for the lord's live room",
    newPlayersTitle: "New Comer Channel",
    newPlayersDesc: "The Boss and lords can view the New Comer channel",
    loadMembersFailed: "Failed to retrieve members list",
    appointFailed: "Setting up Boss Failure",
    appointSuccess: "Setup successful",
    removeFailed: "Appointment termination failed",
    removeSuccess: "Unlocked successfully",
    customerService: "Customer Service",
    loadClubFailed: "Failed to load club information",
  },
  /* 總榜單 */
  allRank: {
    lang1: "Broadcaster",
    lang2: "Rich",
    lang3: "PK",
    lang4: "Club battle",
    lang5: "Chinese",
    lang6: "English",
    lang7: "Thai",
    lang8: "Japanese",
    lang9: "Indonesian",
    lang10: "Vietnamese",
    lang11: "Hour",
    lang12: "Daily",
    lang13: "Weekly",
    lang14: "This week",
    lang15: "Last week",
    lang16: "Monthly",
    lang17: "Rank List",
    lang18: "Reward",
    lang19: "Connection rate",
    lang20: "Club points",
    lang21: "Member",
    lang22: "No data",
    lang23: "Not listed yet",
    lang24: "Fan Club",
    lang25: "Date",
    lang26: "Cannot follow yourself",
    lang27: "Follow successfully",
    lang28: "Unfollowed successfully",
    lang29: "Waiting",
    lang30: "Yesterday",
    lang31: "Last month",
    lang32: "Not on the list",
    lang33: "My ranking",
    lang34: "Emissary",
    lang35: "Monthly Rewards List",
    lang36: "Monthly list of disciple",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "No slogan",
    lang40: "Member",
    lang41: "Member",
    lang42: "Week Reputation",
    lang43: "Total reputation",
    lang44: "Club Ranking",
    lang45: "Share",
    lang46: "Launch",
    lang47: "sent Club invitation",
    lang48: "Launch FIREFLY to have more fun live broadcaster",
    lang49: "Weekly Rewards Ranking",
    lang50: "Weekly Amount Ranking",
    lang51: "REPs",
    lang52: "Reward",
  },

  /* 俱乐部 */
  club: {
    lang1: "Broadcaster",
    lang2: "Rich",
    lang3: "PK",
    lang4: "Club battle",
    lang5: "Chinese",
    lang6: "English",
    lang7: "Thai",
    lang8: "Japanese",
    lang9: "Indonesian",
    lang10: "Vietnamese",
    lang11: "Hour",
    lang12: "Daily",
    lang13: "Weekly",
    lang14: "This week",
    lang15: "Last week",
    lang16: "Monthly",
    lang17: "Rank List",
    lang18: "Reward",
    lang19: "Connection rate",
    lang20: "Club points",
    lang21: "Member",
    lang22: "No data",
    lang23: "Not listed yet",
    lang24: "Fan Club",
    lang25: "Date",
    lang26: "Cannot follow yourself",
    lang27: "Follow successfully",
    lang28: "Unfollowed successfully",
    lang29: "Waiting",
    lang30: "Point Contribution Chart",
    lang31: "Rank",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "No slogan",
    lang40: "Member",
    lang41: "Member",
    lang42: "Week Reputation",
    lang43: "Total reputation",
    lang44: "Club Ranking",
    lang45: "Share",
    lang46: "Launch",
    lang47: "sent Club invitation",
    lang48: "Launch FIREFLY and join the club for fun~",
    lang49: "Fans group",
    lang50: "Lord: ",
    lang51: "Boss: ",
    // Role badge on the "My Rank" row of the club ranking page.
    lang52: "Lord",
    lang53: "Boss",
    lang54: "Member",

    lang55: "No club affiliation",

    lang56: "No club affiliation set",
  },

  /* 榜单 */
  rank: {
    lang1: "Broadcaster",
    lang2: "Rich",
    lang3: "PK",
    lang4: "Club battle",
    lang5: "Chinese",
    lang6: "English",
    lang7: "Thai",
    lang8: "Japanese",
    lang9: "Indonesian",
    lang10: "Vietnamese",
    lang11: "Hour",
    lang12: "Daily",
    lang13: "Weekly",
    lang14: "This week",
    lang15: "Last week",
    lang16: "Monthly",
    lang17: "Rank List",
    lang18: "Reward",
    lang19: "Connection rate",
    lang20: "Club points",
    lang21: "Member",
    lang22: "No data",
    lang23: "Not listed yet",
    lang24: "Fan Club",
    lang25: "Date",
    lang26: "Cannot follow yourself",
    lang27: "Follow successfully",
    lang28: "Unfollowed successfully",
    lang29: "Waiting",
    lang30: "Yesterday",
    lang31: "Last month",
    lang32: "Not on the list",
    lang33: "My ranking",
    newDraw96: "Private-call",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY Top Ranking",
    playerCoreTitle: "Top Players",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Top Streamers",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Ranking Group",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Charm Ranking Group",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Charm Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Vehicle Hall of Fame",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "FIREFLY Garden Ranking",
    firstLoveBoard: "First Gift Ranking",
    newStarBoard: "NewStar Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private-Call Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "Broadcaster",
    lang2: "Rich",
    lang3: "PK",
    lang4: "Club battle",
    lang5: "Chinese",
    lang6: "English",
    lang7: "Thai",
    lang8: "Japanese",
    lang9: "Indonesian",
    lang10: "Vietnamese",
    lang11: "Hour",
    lang12: "Daily",
    lang13: "Weekly",
    lang14: "This week",
    lang15: "Last week",
    lang16: "Monthly",
    lang17: "Rank List",
    lang18: "Reward",
    lang19: "Connection rate",
    lang20: "Club points",
    lang21: "Member",
    lang22: "No data",
    lang23: "Not listed yet",
    lang24: "Fan Club",
    lang25: "Date",
    lang26: "Cannot follow yourself",
    lang27: "Follow successfully",
    lang28: "Unfollowed successfully",
    lang29: "Waiting",
    lang30: "Point Contribution Chart",
    lang31: "Rank",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "No slogan",
    lang40: "Member",
    lang41: "Member",
    lang42: "Week Reputation",
    lang43: "Total reputation",
    lang44: "Club Ranking",
    lang45: "Share",
    lang46: "Launch",
    lang47: "sent Club invitation",
    lang48: "Launch FIREFLY to have more fun live broadcaster",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "Cherish value record",
    income10: "This month",
    income11: "Last month",
    news7: "Matters",
    news13: "Fan Value",
    cashreal6: "Cancel",
    box1: "No records yet",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "Club's intro",
    lang2:
      "The club is a group composed of the anchor's core fans. By joining a club, you can participate in fun events  and competitions together, and become friends with members in the same club. The number of fan groups and reputation are the main competitive points of the club, and they also symbolize the influence and popularity of the founding anchor.",
    lang3: "Introduction to the club’s specialized attributes",
    lang4: "C.by creator:",
    lang5:
      "The founder of the club, usually the anchor. The anchor will open the club after the number of people he followed reaches a certain number.",
    lang6: "P.by President:",
    lang7:
      "The manager of the club will take effect after being designated by the host. The president of the club also becomes the live broadcast room manager of the creator of C.by.",
    lang8: "Member:",
    lang9:
      'Members of the club. The way to join is to send a "Cherish You" or "Cherish Together" gift during the live broadcast. There is no limit to the number of members in any club.',
    lang10: "Exclusive gifts:",
    lang11:
      "Club competitions with specialized gifts. Send club gifts to gain club points.",
    lang12: "Club points:",
    lang13:
      "1. Send club-exclusive gifts in the club’s founder’s live broadcast room to accumulate club points. 2. Complete daily club tasks in the club founder's live broadcast room to accumulate club points.",
    lang14: "Reputation:",
    lang15:
      "The sum of the club points ​​of all members in the same club is the reputation of the club. The sum of the club points increased by all members in the club every week is the weekly reputation of the club.",
    lang16: "Member's level",
    lang17:
      "1. The process of accumulating club points is the process of completing the upgrade. Please refer to the icon above for details. 2. sending club gifts. 10 gem = 1 Club point (does not affect other attributes of the gift). 3. The club points will no longer increase after it reaches the upper limit on the day.",
    lang18: "Member's downgrade",
    lang19:
      "1. In the club, when a member does not contribute any club points for 3 consecutive days, the club points will begin to decay from the 4th day. 2. The continued decline of the club point will cause the member to be downgraded. Please refer to the member's level for details. 3. If the club points drops to 0, the member will automatically quit the club.",
    lang20: "Member's privileges",
    lang21: "other",
    lang22:
      "If a club has fake accounts, cheats, or has a name or cover that violates local laws and regulations, the FIREFLY platform has the right to modify or delete the club.",
    lang23: "Club level",
    lang24: "Points required for upgrade",
    lang25: "Daily bonus",
    lang26: "Club points upper limit",
    lang27: "Attenuation",
    lang28: "Privilege",
    lang29: "Description",
    lang30: "Club nameplate",
    lang31:
      "Special level identification in the C.by creator’s live broadcast room",
    lang32: "Exclusive Gift",
    lang33: "Exclusive gifts in the C.by creator’s live broadcast room",
    lang34: "Exclusive chat box",
    lang35: "Exclusive chat box in the C.by creator’s live broadcast room",
    lang36: "Club Treasure box",
    lang37:
      "You can grab the privileges of the club treasure box in the live broadcast room of the creator of C.by",
    lang38: "Daily bonus",
    lang39:
      "You can complete daily tasks in the C.by creator’s live broadcast room to receive gift packs.",
    lang40: "Members chat",
    lang41:
      "Chat with all members of the club in private messages without any intimacy restrictions",
    lang42: "Refresh",
    lang43: "Customer Service",
    lang44: "Close Page",
    lang45: "Club",
    lang46: "Club",
    lang47: "Club are exclusive camps jointly established by players and lords. Players can join club, contribute reputation to the clubs, compete with other clubs for honor, and win exclusive ranking rewards!",
    lang48: "Membership Club",
    lang49: "Each player can set up to one of their own membership club. After setting up membership, your role in the club will change to 'Member'. After setting up membership, honors and reputation (such as ranking champions, Glow Night Showdown champions, etc.) and winning games in the PK room will automatically contribute to the membership club.",
    lang50: "Join/quit club",
    lang51:
      "Players join a lord’s club by sending the lord a 「Yingxin Bell」 gift. After joining through a gift, your role is 「Guest」. Players are free to leave the club at any time.",
    lang52: "REPs",
    lang53: "Reputation is the core of competition among Club. Reputation is contributed to the club by all its members through completing club tasks, winning the ranking list, winning the events, and participating in and winning games.",
    lang54: "Club Reward",
    lang55: "When the club wins the reward through competition, it will be sent to the Boss of the club. If the club has not set up a Boss, it cannot receive the club's reward.",
    lang56: "Club Ranked",
    ranked: "Ranked",
    lang57: "A club meets the following conditions to participate in the FIREFLY Club Ranking",
    lang58: "Changed the club name",
    lang59: "Changed the club cover",
    lang60: "The Boss has been set",
    lang61: "Clubs that do not meet the above conditions do not affect the normal players' joining and reputation accumulation, but they cannot participate in the ranking list.",
    lang62: "Club Role",
    // 社团角色区域的英文副标题，与其他语言文件保持相同键。
    lang63: "Club Role",
    lang64: "Load",
    lang65: "The lord is the founder of the club, deeply bound to it. The lord has the management and editing rights of the club, and can appoint a Boss for the club.",
    lang67: "Appointed by the lord, with the management and editing rights of the club. Can start the PK room of the club in which they are located.",
    lang68: "<span class='highlight-text'>Club Reward:</span> All rewards will send to the club boss. If the club has not set up a club boss, it will not be able to receive the club reward.",
    lang69: "Members",
    lang70:
      "Players who have joined the club and designated it as their 「affiliated club」. Reputation rewards earned from honors and games are automatically contributed to their affiliated club.",
    lang71: "Guest",
    lang72:
      "Players who have joined the club but have not designated it as their 「affiliated club」.",
    lang73: "King of the Club",
    lang74: "Every week, the Top1 club of FIREFLY's Club weekly ranking becomes the 'King of the Club' for the next week. During the effective period of the King of the Club, guests cannot set the King of the Club as the club membership. The club name of the King of the Club members will be displayed in all live rooms.",
    lang75: "More",
  },

  /* 游戏 - 萤火花园 */
  fireflyGarden: {
    lang1: "Garden",
    lang2: "Tasks",
    lang3: "List",
    lang4: "Garden Records",
    lang5: "Planting flowers",
    lang6: "Watering",
    lang7: "Watered",
    lang8: "Data empty",
    lang9: "Garden Rules",
    lang10:
      "Players click on a flowerpot to select the flower they want to plant. After planting, wait for the flower to bloom. A random gift of varying value will be revealed. The player's Rich increase based on the flower's price. If the livestream is closed before the flower blooms, the GEMs will be refunded.",
    lang11:
      "Players can use the 'Garden Watering Card' to water flowers planted by others. Each watering speed up the blooming time by 1 minute.",
    lang12: "Flower Level",
    lang13:
      "Level up based on the value of the gifts bloomed by the flower. Higher levels unlock more flowers to plant.",
    lang14: "Pot Level",
    lang15:
      "Available based on the value of the gifts bloomed by the flowers planted in this pot. Higher pot levels reduce more flowering time. <br> One-star pot: Flowering time reduced by 1 minute <br> Two-star pot: Flowering time reduced by 2 minutes <br> Three-star pot: Flowering time reduced by 4 minutes",
    lang16: "All Collected",
    lang17:
      "Each flower can yield a different gift. Once you've collected all the gifts from a flower, you've achieved a \"All-Collected.\" Collecting all common flowers unlocks star-level flowers, and collecting all star-level flowers grants corresponding rewards.",
    lang18: "This week",
    lang19: "Last week",
    lang20: "This month",
    lang21: "Last month",
    lang22:
      "The weekly ranking winner will receive a gift: Flower Sea Tour x1.",
    lang23: "All collected unlock",
    lang24: "Unlock",
    lang25: "Pick a flowers to plant",
    lang26: "Cancel",
    lang27: "Send",
    lang28: "OK",
    lang29: "Blooming Time:",
    lang30: "minute",
    lang31: "Bloom to send the random gift below",
    lang32: "Collected",
    lang33: "All Collected",
    lang34:
      "The flowers blooming will send a gift means collected. Reach All collceted to receive",
    lang35:
      "The flowers blooming will send a gift means collected. Reach All collceted to unlocks hidden flowers.",
    lang36: "Unlocked",
    lang37: "Unlocked",
    lang38: "Received",
    lang39: "Receive",
    lang40: "The Hidden Epiphyllum has been unlocked.",
    lang41: "Reach All Collected to receive",
    lang42: "Complete daily garden tasks to receive item rewards.",
    lang43: "Complete",
    lang44:
      "The weekly ranking winner will receive a gift: Flower Sea Tour x1.",
    lang45: "A new episode of Firefly Garden has begun. Please restart.",
    lang46: "Garden Watering Cards",
    lang47:
      "The top 30 players in the monthly rankings will receive a reward 'Garden Level-Up Card'",
    lang48: "Flowers level reach Lv.$ to unlock",
    lang49: "Complete full collection, unlock",
    lang50: "days",
    lang51:
      'Please go to "Task Center" - "Rewards Claim" to claim your rewards.',
    lang52: "Receive",
    lang53: "「Garden Watering Cards」Insufficient quantity",
    lang54: "Uncollected",
    lang55: "Complete the full collection and receive rewards",
    lang56: "Gift Probability",
    lang57: "Gift Details",
    lang58: "Gift Name",
    lang59: "Opening Probability",
    lang60: "Limited",
    task1Title: "Daily Check-in",
    task1Desc: "Daily check-in to receive.",
    task2Title: "Daily Top-up",
    task2Desc: "Daily top-up to receive",
    task3Title: "Plant flowers daily.",
    task3Desc: "Completing daily flower planting to receive",
  },

  /* 極速狂飈 */
  kingOfSpeed: {
    lang1: "Game Rules",
    lang2: "Game Description",
    lang3:
      "1. Roll the dice: Each click on Roll the dice costs 1000 DEWs. Rolling the dice grants bonuses to the team's car.",
    lang4:
      "2. Dice Probability: The probability of each of the six effects being drawn is the same, but the bonus effects on each of the six sides are different.",
    lang5:
      "3. Game Result: At the end of the game PK time, the team with the higher distance wins, and the team with the lower distance loses. If both teams have the same distance, it's a draw.",
    lang6: "Car Description",
    lang7:
      "1. Car Requirements: If the broadcaster does not have a car at the start of the game, the current team's car cannot be formed.",
    lang8: "Qi level description",
    lang9:
      "1. Level Up: Players interact with each other to increase the broadcaster's popularity. Popularity is used to increase the team's Qi level. The higher the Qi level, the stronger the dice bonus effect.",
    lang10: "2. Qi Level Requirements:",
    lang11: "Dice Level",
    lang12: "Popularity",
    lang13: "DEWs Pool Description",
    lang14:
      "1. DEWs Pool: The DEWs from the dice rolled by both players will accumulate into the DEWs Pool. At the end of the game, the winning team will receive all the DEWs in the pool as a reward. In the event of a draw, players from both teams will receive rewards from the DEWs Pool.",
    lang15:
      "2. Reward Distribution: Rewards are distributed based on the DEWs percentage of each player's dice roll on the winning team. Players who did not roll the dice to participate in the game do not participate in the Dew Pool reward distribution.",
    lang16:
      "3. Service Fee: Players receive rewards from the DEWs Pool. The platform will charge a 4% service fee.",
    lang17: "Game Development Notes",
    lang18:
      "1. Players can participate in the King of Speed through in-game PKs from 12:00 PM on October 23, 2025, to 12:00 AM on November 17, 2025.",
    lang19: "Precautions",
    lang20: "1. All times within the event are based on server time.",
    lang21:
      "2. To ensure game fairness, the platform reserves the right to adjust or suspend any irregularities in the game due to force majeure factors, such as network issues, cheating, or other unauthorized activities.",
    lang22:
      "3. This game is for entertainment purposes only. Offline transactions between players or broadcaster are strictly prohibited. Beware of scams or attempts to gain illicit benefits.",
    lang23:
      "4. The platform is not responsible for any game losses caused by personal network or device issues.",
    lang24:
      "5. The platform reserves the right of final interpretation of the game.",
    lang25: "PK Game Records",
    lang26: "PK Time",
    lang27: "Rolling dice",
    lang28: "PK Team",
    lang29: "Distance",
    lang30: "Results",
    lang31: "Loading...",
    lang32: "No more records",
    lang33: "No game PK records",
    lang34: "The other broadcaster doesn't have a car.",
    lang35: "Blue team does not have a car",
    lang36: "Red Team has no car.",
    lang37: "Speed ​​limit to",
    lang38: "Speed",
    lang39: "Broadcaster must get a car to join the game.",
    lang40: "Departure",
    lang41: "Tips",
    lang42: "Currently do not own a car, so cannot participate in the PK game",
    lang43: "Go to",
    lang44: "DEWs Pool",
    lang45: "Our Team",
    lang46: "Opposite",
    lang47: "Throw",
    lang48: "My Roll:",
    lang49: "Prize information",
    lang50: "1. DEWs Pool:",
    lang51:
      "The DEWs from the dice rolled by both players will be added to the DEWs Pool. At the end of the game, the winning team will receive all the DEWs in the DEWs Pool as a reward. In a tie, both players ",
    lang52: "2. Reward Distribution:",
    lang53:
      "Rewards are distributed based on the DEWs percentage of each player's dice roll on the winning team. Players who did not roll the dice to participate in the game do not participate in the DEWs Pool reward distribution.",
    lang54: "3. Service Fee:",
    lang55:
      "Players receive rewards from the DEWs Pool, and the platform will charge a 4% service fee.",
    lang56: "OK",
    lang57: "Speed​Up",
    lang58: "Shield",
    lang59: "Charge",
    lang60: "Red Team",
    lang61: "Blue Team",
    lang62: "Racing Car Details",
    lang63: "Activating",
    lang64: "unactivated",
    lang65: "second",
    lang66: "Speed ​​x2, continuous",
    lang67: "Protecting",
    lang68: "Unprotected",
    lang69: "Shields provide resist to negative effects once.",
    lang70: "(Interference, Speed ​​Limit)",
    lang71: "Continued",
    lang72: "Activating",
    lang73: "unactivated",
    lang74:
      "When the Charge Value is full, the car speed is x3, and the duration is ",
    lang75: "Speed ​​Boost Duration",
    lang76: "Speed ​​Up",
    lang77: "Turbo Mode:",
    lang78: "Shield duration",
    lang79: "Interference",
    lang80: "Interference Mode:",
    lang81: "Speed ​​limit",
    lang82: "Car Gains",
    lang83:
      "Charge Value: When the Charge Value reaches 100%, Charging Mode activates. Charging Speed ​​is x3, and the duration is ",
    lang84: "Exit after time expires.",
    lang85: "Charge Mode",
    lang86: "Charge reset",
    lang87: "Cars receive a speed boost.",
    lang88: "Continuous",
    lang89: "Speed ​​will be restored after the time expires.",
    lang90: "Racing wins",
    lang91: "Bonus",
    lang92: "Speed",
    lang93: "Continuous",
    lang94: "Resist once",
    lang95: "Negative Effect",
    lang96:
      "When multiple shield bonuses are granted, the shield stacks are stacked. After the timer expires or an immunity is applied, the shield stack decreases by 1.",
    lang97: "Uses a disruption effect, targeting the opponent.",
    lang98: "Interference",
    lang99: "After it takes effect, the car's normal speed will be reduced.",
    lang100:
      "Use the Speed ​​Limit effect to deliver a slowdown sign to the opponent, slowing their car.",
    lang101: "Interference",
    lang102: "Speed ​​limit",
    lang103: "Rolling dice",
    lang104: "Roll the dice to gain bonuses.",
    lang105: "Speeding! Sprinting Together!",
    lang106:
      "The slogan has been copied. Please paste it into the input box and send it!",
    lang107: "Copy Failed",
    lang108: "Participate in the racing game",
    lang109: "Requirements",
    lang110: "Broadcaster owns a car.",
    lang111: "Achieved",
    lang112: "Not achieved",
    lang113: "Join a PK Team",
    lang115: "Click to send a car",
    lang116: "Click to send a team slogan",
    lang117: "The current game is not active, so dice can not be roll.",
    lang118: "Broadcaster is not allowed to roll the dice.",
    lang119: "Speed ​​Rush, winner takes all!",
    lang120: "Game Not Started",
    lang121: "[King of Speed] is not enabled and cannot be played.",
    lang122: "Racing gets shield bonus",
    lang123: "No vehicle",
    lang124: "leading",
    lang125: "backward",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "Live assistant",
    lang2:
      "Bound player as Live assistant, the player will receive your share of the FIREs received.",
    lang3: "Bound Live assistant",
    lang4: "Enter ID to confirm bound player",
    lang5: "Enter the Player ID You Want to Bind",
    lang6: "Next",
    lang7: "FIREs share ratio",
    lang8: "Binding Instructions",
    lang9:
      "After binding your Live assistant, the Live assistant will receive a share of the FIREs you collect. The FIREs you collect through gifts will be sent to the Live assistant according to the FIREs share ratio you set.",
    lang10: "Sure",
    lang11: "Bind Live Assistant",
    lang12: "Confirm Binding?",
    lang13: "Your Live assistant",
    lang14: "Cancel",
    lang15: "Binding success",
    lang16: "Binding failed",
    lang17: "Unbinding successful",
    lang18: "Unbinding failed",
    lang19:
      "Bound player as Live assistant, the player will receive your share of the FIREs received.",
    lang20: "My Live Assistant",
    lang21: "Unbind",
    lang22: "Pending Confirmation",
    lang23: "Unbind Live Assistant",
    lang24:
      "Unbinding from a Live assistant requires confirmation from the opposite. Unbind?",
    lang25: "Your Live assistant?",
    lang26: "Unbinding Rejected",
    lang27: "Unbinding Rejected Failed",
    lang28: "Live assistant settings",
    lang29: "New FIREs",
    lang30:
      "The opposite has unbound your Live assistant status; your confirmation is required.",
    lang31: "Unbinding Request",
    lang32:
      "The opposite has applied to unbind your Live assistant account. Please confirm.",
    lang33: "Reject",
    lang34: "List of streamers bound me as Live assistant",
    lang35: "No streamers bound yet",
    lang36: "Unbind Live Assistant",
    lang37: "Unbind?",
    lang38: "What is your Live assistant relationship?",
    lang39: "The user has been banned.",
    lang40: "The search for the ID you entered failed.",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang1: "Rules",
    lang2: "Live Status",
    lang3: "Historial",
    lang4: "You have forfeited today's entry",
    lang5: "Failed to Forfeit Today's Participation",
    lang6: "Forfeit Entry",
    lang7: "My ranking",
    lang8: "Wins",
    lang9: "Competition Instructions",
    lang10:
      "Broadcasters who advance to the Semi-Finals/Finals must be live and not currently in another PK match at the designated start time. The system will then automatically initiate the PK between the two respective broadcasters.",
    lang11: "Semi-finals",
    lang12: "Best-of-5 format, the winning broadcaster advances to the Finals",
    lang13: "Audition No.1 VS Audition No.4",
    lang14: "Audition No.2 VS Audition No.3",
    lang15: "Finals",
    lang16:
      "Best-of-5 format, the winning broadcaster becomes the 'Glow Night Showdown' Champion of the day",
    lang17: "Semi-Final Winner",
    lang18:
      "Note: If you meet the participation requirements for the Semi-Finals/Finals but are unable to join, please click here before 20:30 daily",
    lang20:
      "Absence from the match will result in being unable to participate in the 'Glow Night Showdown' event for the next 15 days.",
    lang22:
      "Forfeiting the match will remove you from the Audition ranking, and your eligibility will be restored the next day.",
    lang23: "Do you wish to forfeit today's participation?",
    lang24: "Firefly Glow Night Showdown Event",
    lang25: "Cancel",
    lang26: "Sure",
    lang27: "Wins",
    lang28: "DNF",
    lang29: "No Past Records Available",
    lang30: "Participate in the 'Glow Night Showdown'",
    lang31:
      "Broadcasters using FIREFLY V54.0 or above to start a PK (including 'Popularity PK' and 'Game PK') are eligible to participate in the Glow Night Showdown event.",
    lang32: "Audition",
    lang33: "Time: Daily 20:30 - 20:30 the next day",
    lang34:
      "Rules: Start a PK with a host who has earned “New Star Rising” to enter that day’s preliminary leaderboard. Hosts are ranked by the total popularity points earned in all PK matches they complete that day.",
    lang35:
      "Advancement: The top 4 broadcasters in the Audition ranking by 20:30 daily will advance to the Semi-Finals.",
    lang36:
      "Forfeit Entry: If a broadcaster is unable to go live during the designated time for the Semi-Finals/Finals, they can choose to forfeit during the Audition period. The next highest-ranked broadcaster will take their spot.",
    lang37: "Semi-finals",
    lang38: "Time: Daily at 21:00 / 21:20",
    lang39:
      "Rule: The system will automatically initiate the PK match between the two Semi-Final broadcasters at the designated time. The PK rule is 'Popularity PK' in a Best-of-5 format. Broadcasters must remain live during this time.",
    lang40: "Advancement: The winner will advance to the Finals",
    lang41:
      "Forfeit Entry: A broadcaster is considered to have forfeited if they are not live at the start of the Semi-Finals. They will not receive ranking rewards and will be ineligible to participate in the 'Glow Night Showdown' for the next 15 days.",
    lang42: "Semi-finals: Generated by random draw after the daily audition ends",
    lang44:
      "The Semi-Final losers will be ranked No.3/No.4 based on their highest Popularity Value of the day.",
    lang45: "Finals",
    lang46: "Time: Daily at 22:00",
    lang47:
      "Rule: The system will automatically initiate the PK match between the two Finalist broadcasters at the designated time. The PK rule is 'Popularity PK' in a Best-of-5 format. Broadcasters must remain live during this time.",
    lang48:
      "Advancement: The winner is crowned the 'Glow Night Showdown' Champion of the day",
    lang49:
      "Forfeit Entry: A broadcaster is considered to have forfeited if they are not live at the start of the Finals. They will not receive ranking rewards and will be ineligible to participate in the 'Glow Night Showdown' for the next 15 days.",
    lang50:
      "The Finals winner is the day's Champion, and the loser is the day's No.2",
    lang51: "Reward",
    lang52: "Player DEWs Reward:",
    lang53: "Semi-Final 1: The winning team will split the ",
    lang54: "Semi-Final 2: The winning team will split the ",
    lang55: "Finals: The winning team will split the ",
    lang56: "Broadcaster Point Reward:",
    lang57:
      "Broadcasters participating in the Semi-Finals/Finals, after a winner is determined, the top 4 will receive points for the 'Livestream Reward'. Broadcasters who forfeit will not receive point rewards. Please check here for specific points.",
    lang58: "live broadcast rewards>",
    lang59: "Precautions",
    lang60: "1. The event is limited to female anchors",
    lang61:
      "2. During the period when your eligibility to participate in the activity is restricted, all activity data will be invalid and must be obtained again after the restriction is lifted.",
    lang62:
      "3. Streamers must actively interact with players. The platform reserves the right to disqualify streamers and strip them of their activity points for any behavior that violates the \"Streamer Agreement\" or disrupts the balance of the event (including but not limited to: face-revealing streams, low-quality streams, black screens, AFK streams, streaming while playing games, watching TV, colluding in PvP results, and passive play). Streamers who violate the above rules will be subject to a 'red card penalty' by the platform.",
    lang63:
      "4. The platform reserves the right of final interpretation for this event.",
    lang64: "In Audition",
    lang65: "20:30 - 20:30 the next day",
    lang66:
      "Start a PK with a host to enter the preliminary leaderboard. The leaderboard ranks participants by the popularity points earned in valid PK matches completed that day. The top 4 advance to the semifinals.",
    lang67: "Promotion Zone",
    lang68: "No Audition Records Available",
    lang69:
      "'FIREFLY' You have reserved a spot for the Glow Night Showdown Finals",
    lang70: "Daily 21:00-23:00, PK winners receive DEWs rewards",
    lang71: "Finalist Broadcaster Not Determined",
    lang72: "Semi-Final Broadcasters Not Determined",
    lang74: "Audition NO.1",
    lang75: "Audition NO.2",
    lang76: "Audition NO.3",
    lang77: "Audition NO.4",
    lang78: "Reminder >",
    lang79: "Reward",
    lang80: "Best-of-5",
    lang81: "Ranking Locked",
    lang82: "No ranking yet",
    lang83:
      "'FIREFLY' You have booked the fluorescent night talent show semi-final 1",
    lang84:
      "'FIREFLY' You have booked the fluorescent night talent show semi-final 2",
    lang85: "Loading more...",
    lang86: "Scroll down to load more",
    lang87: "No more",
    lang88: "Red Card Penalty:",
    lang89:
      "a. Cancel the reward eligibility for the 'Neon Night Audition' event on that day",
    lang90:
      "b. You are prohibited from participating in the 'Neon Night Audition' event for the next 5 days.",
    lang91: "Reward",
    lang92:
      "Top 4 streamers in the daily 'Fluorescent Night Audition' will receive rewards",
    lang93: "Champion",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "Other Ranks",
    lang97: "No Reward",
    lang98: "Claim",
    lang99: "No Fluorescent Night Audition reward obtained",
    lang100: "Claimed",
    lang101: "You have claimed the Fluorescent Night Audition reward",
    lang102: "Claim successful",
    lang103: "Streamers can receive gem rewards:",
    lang104: "Champion:",
    lang105: "2nd Place:",
    lang106: "3rd/4th Place:",
    lang107: "Finals Rewards",
    lang108: "Results",
    lang109: "Reward",
    lang110: "Win",
    lang111: "Loss",
    lang112: "Incomplete",
    lang123: "No Reward",
    lang124: "Semi-Finals Rewards",
    lang125: "Preliminary Rewards",
    lang126: "Finals Rewards",
    lang127:
      'Participate in the "Fluorescent Night Audition" Finals. Rewards can be claimed after the Finals end.',
    lang128: "Semi-Finals Rewards",
    lang129:
      'Participate in the "Fluorescent Night Audition" Semi-Finals. Rewards can be claimed after the Finals end.',
    lang130: "Preliminary Rewards",
    lang131:
      'Top 8 in the "Night Audition Finals" can claim. Distributed daily at 21:00.',
    lang132: "Not Started",
    lang133: "In PK",
    lang134: "Ended",
    lang135: "No rewards available to claim",
    lang136: "You have already claimed the reward",
    lang137: "Participate in Fluorescent Night Audition PK, win ",
    lang138: "Claim",
    lang139: "Claimed",
    lang140: "Claim All",
    lang141: "My Rewards",
    lang142: "Medium",
    lang143: "NO.1-NO.4",
    lang144: "Preliminary Ranking",
    lang145: "NO.5-NO.8",
    lang146: "No Reward",
    lang147: "Other Rankings",
    lang148: "Did Not Participate",
    lang149: "Reward Zone",
    lang150: "Please update the APP to V57.0 or above to claim rewards!",
    lang151: "Stage Result",
    lang152:
      "Available to claim after today's Night Draft final rankings are decided",
    lang153: "Audition Top4",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "New players who register within 7 days and complete the 'First Recharge Gift Pack' recharge event will receive a 'FirstLove' gift reward. Sending the 'FirstLove' gift will bind the streamer to FirstLove, and their comments in the live stream will have a special tag. Each player can only bind one FirstLove account.",
    lang3: "First Recharge Gift Pack Entry",
    lang4: "Sending Gifts",
    lang5: "FirstLove Ranking",
    lang6:
      "The FirstLove Ranking is based on the number of FirstLove gifts received by streamers; those receiving more gifts rank higher. If multiple streamers receive the same number of FirstLove gifts,",
    lang7: "Streamers who reach this number first will rank higher.",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "Daily rewards",
    lang2: "Reward Record",
    lang3: "【Welcome Task】",
    lang4: "Points",
    lang5:
      "Complete the 'Welcome PK' event; you can receive a maximum of 6000 points per day.",
    lang6: "Welcome PK",
    lang7:
      "Earn points for each completed 'Welcome PK' (1 hour) based on the PK result.",
    lang8: "Event",
    lang9: "Already Obtained",
    lang10: "Receive",
    lang11: "Claimed",
    lang12: "Points Redemption",
    lang13: "My Points",
    lang14: "Rewards",
    lang15: "Stage",
    lang16: "Accumulated Points Reached",
    lang19: "Points Reward",
    lang20: "Welcome Rewards",
    lang21: "Daily Welcome PK event with exclusive traffic support.",
    lang25: "LIKEs",
    lang26: "No data available",
    lang27: "Welcome Reward Rules",
    lang29:
      "When a new streamer start a PK, they select 'Welcome PK' and begin matchmaking. The Welcome PK compete for the number of LIKEs received by both streamers.",
    lang30: "How to get LIKEs:",
    lang31: "Receive exclusive gifts for new players",
    lang32: "Exclusive Gift Description:",
    lang33: "Gift Name:",
    lang34: "How to Obtain:",
    lang35:
      "Newly registered players will receive this gift for free, valid for 48 hours. You can claim it by clicking 'Newcomer Gift' in the live stream room.",
    lang36: "Like",
    lang37: "FirstLove",
    lang38:
      "New players who complete the 'First Recharge Gift Pack' recharge event within 7 days of registration will receive the 'FirstLove' gift reward.",
    lang39: "You have already claimed today's points.",
    lang40: "Unable to claim points if reward requirements are not met.",
    lang41: "Successfully claim Welcome Reward Points",
    lang42: "Welcome User Support",
    lang43:
      "Activating 'Welcome PK' will grant you welcome traffic support. Newly registered players during the Welcome PK period will be automatically pushed to the 'Welcome PK' live stream room.",
    lang44: "Points Claim",
    lang45:
      "Complete 'Daily Rewards' to earn points. Accumulate points to reach the corresponding level to receive Firefly Rewards.",
    lang46: "Notes",
    lang47: "1. This event is only open to female streamers.",
    lang48:
      "3. Only one account per device can claim the reward; multiple accounts claiming the reward will result in disqualification and will not be reinstated.",
    lang49:
      "4. During the period of restricted participation, all event data is invalid and must be retrieved again after the restriction is lifted.",
    lang50:
      "5. Daily reward points must be claimed manually. Please claim them before 12:00 PM on December 3, 2025. Late claims will not be reissued.",
    lang51:
      "6. Accounts already linked to an inviter are not allowed to create secondary accounts for live streaming and claiming points. Once discovered, all accounts will be disqualified and the eligibility will not be reinstated.",
    lang52:
      "7. Accounts without an inviter are not subject to account restrictions and may be eligible to participate, but only one account can participate in the reward event.",
    lang53:
      "8. Streamers must actively interact with players. For any behavior that violates the 'Streamer Live Streaming Agreement' or disrupts the balance of the event, the platform has the right to disqualify the streamer and forfeit their event points (including but not limited to face-hanging, low-quality streaming, black screen, AFK, streaming game play, watching TV, etc.).",
    lang54:
      "9. The platform reserves the right to final interpretation of this event.",
    lang55: "2. Event duration is tallied every two minutes.",
    lang57: "Win",
    lang58: "Draw",
    lang59: "Lose",
    lang60: "Reward Stage 1",
    lang61: "Reward Stage 2",
    lang62: "Reward Stage 3",
    lang63: "Reward Stage 4",
    lang64: "Reward Level",
    lang65: "Points Requirements",
    lang66: "Points Reached",
    lang67: "Available to Claim",
    lang68: "Points Redemption Successful",
    lang69: "Like",
    lang70: "Praise",
    lang71: "You have already claimed today's points",
  },
  /* 合作联系 */
  cooperate: {
    lang1: "Your message has been submitted successfully!",
    lang2: "Your nickname",
    lang3: "Contact medium:",
    lang4: "Contact info:",
    lang5:
      "Thank you very much for your cooperation message and your suggestions for FIREFLY's growth. Our staff will contact you. Please pay attention to the contact information you left.",
    lang6: "Host cooperation introduction",
    lang7: "View envoy homepage",
    lang8: "Back to home",
    lang9:
      "FIREFLY hosts, user inviters, or guild members who become envoys can establish a correspondence relationship with their invitees and receive long-term rewards. Outstanding envoys will also automatically gain privileges in the community.",
    lang10: "Please leave your contact info",
    lang11: "Please leave your alternative contact info (optional)",
    lang12: "Your message to FIREFLY",
    lang13: "Please enter your message to FIREFLY",
    lang14: "Confirm submission",
    lang15: "Select contact medium",
    lang16: "Wechat",
    lang17: "Host Cooperation",
    lang18: "Independent hosts join FIREFLY themselves",
    lang19: "Envoy Cooperation",
    lang20: "Join FIREFLY as a guild",
    lang21: "Business Cooperation",
    lang22: "Promotion and Media",
    lang23: "Player Feedback",
    lang24: "FIREFLY player feedback submission channel",
    lang25: "Cooperation Contact",
    lang26: "Please enter your FIREFLY ID",
    lang27: "Please enter your Whatsapp ID",
    lang28: "Please enter your Telegram ID",
    lang29: "Please enter your Facebook ID",
    lang30: "Please enter your Email",
    lang31: "Please enter your Wechat",
    lang32: "Please enter your Line",
    lang33: "Please try again later",
    lang34: "Please enter your nickname",
    lang35: "Please enter your contact info",
    lang36: "Please enter your message",
  },
  premiumNumberCommitLetter: {
    lang1: "Premium ID Activation Commitment",
    lang2: "Dear ",
    lang3: "Original ID:",
    lang4: "Your Applied Premium ID",
    lang5:
      "Activate it for you soon. To maintain platform order and account security, please carefully read and agree to the following terms:",
    lang6:
      "Because the premium id account you have obtained is a scarce and non-renewable resource in the FIREFLY community, the transfer of such accounts will negatively impact the stability and structure of the community.",
    lang7: "【Commitment Agreement】",
    lang8:
      "1. I promise that this premium id account is for my personal use only and will not be provided to any third party in any form (including but not limited to sale, rental, gift, or transfer).",
    lang9:
      "2. I acknowledge that if the above commitment is violated, the platform has the right to reclaim the premium account and may impose restrictions on the original account (such as banning, demotion, etc.).",
    lang10:
      "3. I hereby promise to abide by the platform's relevant user agreements and laws and regulations, and will not use my Premium ID for any illegal or irregular activities.",
    lang11:
      "This commitment is binding upon signing. Thank you for your understanding and cooperation.",
    lang12: "I Disagree",
    lang13: "I Agree",
    lang14: "User Agrees",
    lang15: "Agreement Time:",
    lang16: "Migration Application Submitted",
    lang17:
      "A dedicated customer service representative will contact you to discuss the specific migration time. Thank you for your understanding and support.",
    lang18: "OK",
    lang19:
      "You have successfully applied. Thank you for your understanding and support!",
    lang20: "refresh",
    lang21: "Customer Service",
    lang22: "Close Page",
    lang23: "More",
  },
  vipUpPublicNotice: {
    lang1:
      "To bring you a more prestigious and exclusive interactive experience, we will ",
    lang2: "2026/8/4",
    lang3: "Officially Launched New Rich Level",
    lang4:
      "This adjustment will allocate some of the Rich Value required for VIP Levels and add richer and more impressive privileges. The following are the main changes:",
    lang5:
      "After the new system is updated and launched, the original Rich Level will ",
    lang6: "Automatic inheritance based on Rich Points",
    lang7: "Corresponding VIP Level in the New System",
    lang8:
      "If your previous Rich Level was VIP43 with a Rich Value of 3254120, your level will be transferred to VIP45, with the Rich Value remaining unchanged, and you will receive the corresponding VIP Level privileges!",
    lang9: "Benefit Type",
    lang10: "Specific Privileges",
    lang11: "Unlock Level",
    lang12: "Identity Hide",
    lang13: "Mask",
    lang14: "Management Exemption",
    lang15: "Anti-kick and anti-mute",
    lang16: "Personalized Car",
    lang17: "Customize Exclusive Car",
    lang18: "Premium ID",
    lang19: "6-digit / 5-digit / 4-digit Premium ID",
    lang20: "Colorful Bullet",
    lang21: "3-Color / 5-Color Customization",
    lang22: "Exclusive Service",
    lang23: "Exclusive customer service channel",
    lang24: "Recharge Special Offers",
    lang25: "Exclusive recharge channel",
    lang26: "Personal Card Enhancement",
    lang27: "Static/Dynamic Customized Card Background",
    lang28: "Customized Gifts",
    lang29: "Intermediate Gift (5 seconds) / Advanced Gift (10 seconds)",
    lang30: "World Notification",
    lang31: "Login World Notice",
    lang32: "During the platform's development, we will ",
    lang33:
      "Continuously Improving VIP Level Privileges and Service Experience",
    lang34:
      "If there are any changes to the privilege rules or rights, we will promptly issue an adjustment announcement. Please pay attention.",
    lang35: "Firefly reserves the final right of interpretation",
  },

  // Ludo Game
  ludo: {
    clubPkRoom: "{club}'s PK Room",
    lang1: "Start Room",
    lang2: "Quick Join",
    lang3: "Entry",
    lang4: "Waiting",
    lang5: "Currently no Ludo PK rooms",
    lang6: "Game Mode",
    lang7: "Default Club",
    lang8: "Classic",
    lang9: "Unlimited",
    lang10: "Record",
    lang11: "Ranking",
    lang12: "Entry Dew",
    lang13: "Gameplay Information",
    lang16: "Pay Entry DEWs to Join Ludo PK",
    lang17: "Number of Players",
    lang18: "Winning Rewards",
    lang19: "Reputation",
    lang20: "My Prop",
    lang21: "Piece",
    lang22: "Board",
    lang23: "Select the piece item you use in the LUDO game.",
    lang24:
      "Select the board prop to use in your club's PK room in the LUDO game.",
    lang25: "Time Badge",
    lang26: "Selected",
    lang27: "Default",
    lang28: "Please Select Prop",
    lang31: "Use",
    lang32: "Click to select the prop you want to use",
    lang33: "Click Use, this board item will be used in the next LUDO game.",
    lang34: "Click Use, this piece item will be used in the next LUDO game.",
    lang35: "Already in Use",
    lang36: "Please select the prop to use",
    lang37: "Successful Use, active in the Next LUDO Game",
    lang38: "days",
    lang39: "hour",
    lang40: "min",
    lang42: "Currently no LUDO PK records",
    lang43: "Game Details",
    lang45: "Room Fee",
    lang46: "Time",
    lang47: "DEWs",
    lang49: "Date",
    lang50: "Total",
    lang51: "Player Avatar",
    lang52: "Rank",
    lang53: "1st Place",
    lang54: "2nd Place",
    lang55: "3rd Place",
    lang56: "4th Place",
    lang57: "Loading...",
    lang58: "Customer service",
    lang59: "Win",
    lang60: "Lose",
    lang61: "Draw",
    lang62: "Gameplay Instructions",
    lang63: "Game Rules",
    lang64: "Number of Players",
    lang66: "Win/Loss Determination",
    lang68: "Club Reputation",
    lang69: "Join the Game",
    lang70: "Join Mid-Game",
    lang72: "Takeoff",
    lang73: "Triple Six",
    lang74: "Action",
    lang75: "Stacking Pieces",
    lang76: "Capture Pieces",
    lang77: "Safe Zone",
    lang78: "2-4 players",
    lang79:
      "Classic: Players' pieces must start from the starting point and circle the map to reach the finish line. The game is completed when all pieces reach the finish line. The faster you finish, the higher your ranking.",
    lang80:
      "Depending on the gameplay mode, the player who finishes the game first has the higher ranking. For example, the first player to finish is the winner of that game, and so on.",
    // lang81: "After the game ends, you will receive DEWs and reputation rewards based on your ranking.",
    lang81: "After the game ends, you will receive DEWs.",
    lang82:
      "If you win the game in a club room you have joined, your reputation in that club will increase based on your game rank.",
    lang83: "Pay the host's entry DEWs to join the game.",
    lang84:
      "In an already started game, players can join Ludo PK by paying entry DEWs.",
    lang85:
      "A piece needs to roll a six on the dice to take off from its base and land on the starting square.",
    lang86:
      "If a player rolls three sixes within a turn, a triple six is triggered, and the turn is skipped.",
    lang87: "Players roll the dice to get points to move their pieces forward.",
    lang88:
      "When pieces of the same player remain in the same spot, they form a stack. When a piece is captured, the stack is returned to the player's base.",
    lang89:
      "If another player's piece lands on a square after a piece's turn, all other players' pieces are kicked back to their base and must take off again to move.",
    lang90:
      "Pieces that land on the starting point or shielded squares of the board will not be captured. Pieces from different players can be on these squares simultaneously.",
    lang91:
      "A fixed number of DEWs is charged as a room fee per game. The room fee amount is determined by the number of DEWs collected upon entry and is unrelated to the number of players. When distributing reward DEWs at the end of the game, the system will automatically deduct the room fee and distribute the reward DEWs to the winner.",
    lang92: "Join the Game",
    lang93: "Room Fee",
    lang94: "Wins",
    lang95: "Player",
    lang96: "Settled DEWs",
    lang97: "Match Fee",
    lang98: "Stake",
    lang99: "/game",
    lang100: "My results",
    lang101: "Players",
    lang102: "Records",
  },
  teenPatti: {
    recordTitle: "Records",
    rankingTitle: "Leaderboard",
    confirm: "Confirm",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "Game Settings",
    maxBet: "Maximum Dew Wager",
    maxPot: "Maximum Pot",
    buyInDew: "Buy-in Dew",
    mockJoinTip: "Demo: base Dew {ante} selected. Joining is not connected yet.",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "{club}'s PK Room",
    // 三张牌规则页文案，统一由全局国际化管理。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "Base Dew",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "Start Room",
    lang2: "Quick Join",
    lang3: "Entry",
    lang4: "Waiting",
    lang5: "Currently no Teen Patti PK rooms",
    lang6: "Game Mode",
    lang7: "Default Club",
    lang8: "Classic",
    lang9: "Unlimited",
    lang10: "Record",
    lang11: "Ranking",
    lang12: "Entry Dew",
    lang13: "Gameplay Information",
    lang16: "Pay Entry DEWs to Join Ludo PK",
    lang17: "Number of Players",
    lang18: "Winning Rewards",
    lang19: "Reputation",
    lang20: "My Prop",
    lang21: "Piece",
    lang22: "Board",
    lang23: "Select the piece item you use in the LUDO game.",
    lang24:
      "Select the board prop to use in your club's PK room in the LUDO game.",
    lang25: "Time Badge",
    lang26: "Selected",
    lang27: "Default",
    lang28: "Please Select Prop",
    lang31: "Use",
    lang32: "Click to select the prop you want to use",
    lang33: "Click Use, this board item will be used in the next LUDO game.",
    lang34: "Click Use, this piece item will be used in the next LUDO game.",
    lang35: "Already in Use",
    lang36: "Please select the prop to use",
    lang37: "Successful Use, active in the Next LUDO Game",
    lang38: "days",
    lang39: "hour",
    lang40: "min",
    lang42: "Currently no Teenpatti PK records",
    lang43: "Game Details",
    lang45: "Room Fee",
    lang46: "Time",
    lang47: "DEWs",
    lang49: "Date",
    lang50: "Total",
    lang51: "Player Avatar",
    lang52: "Rank",
    lang53: "1st Place",
    lang54: "2nd Place",
    lang55: "3rd Place",
    lang56: "4th Place",
    lang57: "Loading...",
    lang58: "Customer service",
    lang59: "Win",
    lang60: "Lose",
    lang61: "Draw",
    lang62: "Gameplay Instructions",
    lang63: "Game Rules",
    lang64: "Number of Players",
    lang66: "Win/Loss Determination",
    lang68: "Club Reputation",
    lang69: "Join the Game",
    lang70: "Join Mid-Game",
    lang72: "Takeoff",
    lang73: "Triple Six",
    lang74: "Action",
    lang75: "Stacking Pieces",
    lang76: "Capture Pieces",
    lang77: "Safe Zone",
    lang78: "2-4 players",
    lang79:
      "Classic: Players' pieces must start from the starting point and circle the map to reach the finish line. The game is completed when all pieces reach the finish line. The faster you finish, the higher your ranking.",
    lang80:
      "Depending on the gameplay mode, the player who finishes the game first has the higher ranking. For example, the first player to finish is the winner of that game, and so on.",
    lang81: "After the game ends, you will receive DEWs.",
    lang82:
      "If you win the game in a club room you have joined, your reputation in that club will increase based on your game rank.",
    lang83: "Pay the host's entry DEWs to join the game.",
    lang84:
      "In an already started game, players can join Ludo PK by paying entry DEWs.",
    lang85:
      "A piece needs to roll a six on the dice to take off from its base and land on the starting square.",
    lang86:
      "If a player rolls three sixes within a turn, a triple six is triggered, and the turn is skipped.",
    lang87: "Players roll the dice to get points to move their pieces forward.",
    lang88:
      "When pieces of the same player remain in the same spot, they form a stack. When a piece is captured, the stack is returned to the player's base.",
    lang89:
      "If another player's piece lands on a square after a piece's turn, all other players' pieces are kicked back to their base and must take off again to move.",
    lang90:
      "Pieces that land on the starting point or shielded squares of the board will not be captured. Pieces from different players can be on these squares simultaneously.",
    lang91:
      "A fixed number of DEWs is charged as a room fee per game. The room fee amount is determined by the number of DEWs collected upon entry and is unrelated to the number of players. When distributing reward DEWs at the end of the game, the system will automatically deduct the room fee and distribute the reward DEWs to the winner.",
    lang92: "Join the Game",
    lang93: "Room Fee",
    lang94: "Wins",
    lang95: "Player",
    lang96: "Settled DEWs",
    lang97: "Match Fee",
    lang98: "Base Dew",
  },
};
